import { Alert, Button, Select } from "antd";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { startGetUsuariosSeguimiento, startSeguimiento } from "../../../../../../context/actions/detalleActions";

export const InicioSeguimiento = () => {
  const dispatch = useDispatch();
  const { usuarioIniciaSeguimiento } = useSelector(
    (state) => state.detalleReducer.asistencia
  );
  const { asistenciaID } = useParams();
  const [selectedSeguimiento, setSelectedSeguimiento] = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUsuarios = async () => {
      setLoading(true);
      const result = await dispatch(startGetUsuariosSeguimiento());
      if (result?.code === 0 && result?.data) {
        const opciones = result.data.map((usuario) => ({
          value: usuario.usuarioID,
          label: usuario.nombre,
        }));
        setUsuarios(opciones);
      }
      setLoading(false);
    };
    fetchUsuarios();
  }, [dispatch]);

  const handleSeguimiento = async () => {
    const result = await dispatch(
      startSeguimiento({ asistenciaID, usuarioID: selectedSeguimiento })
    );
    if (result?.code === 0) {
      setSelectedSeguimiento(null);
    }
  };

  return (
    <>
      {usuarioIniciaSeguimiento && (
      <Alert
        style={{ marginBottom: 20 }}
        message={`Seguimiento: ${usuarioIniciaSeguimiento}`}
      />
      )}
      <div style={{ marginBottom: 20 }}>
        <Select
          showSearch
          placeholder="Iniciar Seguimiento"
          style={{ width: "100%", marginBottom: 8 }}
          value={selectedSeguimiento}
          onChange={setSelectedSeguimiento}
          options={usuarios}
          loading={loading}
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
        />
        {selectedSeguimiento && (
          <Button type="default" block onClick={handleSeguimiento}>
            OK
          </Button>
        )}
      </div>
    </>
  );
};
